import { render, staticRenderFns } from "./IcraEmri53Taslak.vue?vue&type=template&id=6be9a480"
import script from "./IcraEmri53Taslak.vue?vue&type=script&lang=ts"
export * from "./IcraEmri53Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports